import axios from "axios";
import { createJWTToken } from "../utils/createJWTToken";

export const getAllLanguagesData = () => {
  const result = axios({
    method: "GET",
    url: process.env.REACT_APP_BACKEND_URL + "/api/v1/langs",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "bearer " + createJWTToken(),
    },
  }).then((response) => {
    const result: {
      created_at: string;
      updated_at: string;
      order: number;
      id: number;
      name: string;
      status?: boolean;
    }[] = response.data.data;

    const newResult = result.map(
      ({ created_at, updated_at, order, ...rest }) => ({ ...rest })
    );
    const newArray: { id: number; name: string; status?: boolean }[] =
      newResult;

    const updatedArray = newArray.map((language, index) => {
      language.status = false;
      return language;
    });

    return updatedArray;
  });

  return result;
};
